<template>
    <div class="float-left mr-1">
        <span class="text-primary">
            <i
                class="fa fa-pie-chart fa-lg icon-button"
                title="Visualizar rateio"
                @click.stop="abrirModal()"
            ></i>
        </span>
        <rateio-requisicao-form
            titulo="Visualizar Rateio"
            operacao="D"
            :requisicao="requisicao"
            :comprometimento="comprometimento"
            :mostrarModal="mostrarModal"
            @fecharModal="fecharModal()"
            :dataServicos="dataServicos"
        ></rateio-requisicao-form>
    </div>
</template>

<script>
import RateioRequisicaoForm from './RateioRequisicaoForm'

export default {
    props: {
        requisicao: {
            type: Object
        },

        comprometimento: {
            type: Object
        },

        dataServicos: {
            type: Object
        }
    },

    components: {
        RateioRequisicaoForm
    },

    data() {
        return {
            mostrarModal: false
        }
    },

    methods: {
        fecharModal() {
            this.mostrarModal = false
        },

        abrirModal() {
            this.mostrarModal = true
        }
    },

    computed: {},

    created() {}
}
</script>
